import { useMutation, useQueryClient } from '@tanstack/react-query';
import { OilSupplierService, UpdateOilSupplierDto } from '../../openapi';
import { OilSupplierMutationKeys } from './constants';

export const useUpdateOilSupplierMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [OilSupplierMutationKeys.UPDATE_OIL_SUPPLIER],
    mutationFn: ({ id, data }: { id: string; data: UpdateOilSupplierDto }) =>
      OilSupplierService.oilSupplierControllerUpdate(id, data),
  });
};
